var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Base } from './base';
var NotIdle = /** @class */ (function (_super) {
    __extends(NotIdle, _super);
    function NotIdle() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.immediate = false;
        _this.listenerAction = function () {
            _this.wasInteractiveLastPeriod = true;
        };
        _this.tick = function () {
            _this.timer += 1;
            if (_this.immediate && _this.wasInteractiveLastPeriod) {
                _this.callback();
                _this.wasInteractiveLastPeriod = false;
            }
            if (_this.timer === _this.timeout) {
                _this.timer = 0;
                if (!_this.immediate && _this.wasInteractiveLastPeriod) {
                    _this.callback();
                    _this.wasInteractiveLastPeriod = false;
                }
            }
        };
        return _this;
    }
    /**
     * @param interactions set of interactions which will prevent being idle
     */
    NotIdle.prototype.when = function (interactions) {
        this.concatInteractions(interactions);
        return this;
    };
    /**
     * Adds default interactions to decide if user is not interacting with page.
     */
    NotIdle.prototype.whenInteractive = function () {
        this.pushDefaultInteraction();
        return this;
    };
    /**
     * Runs not idle action immediately when an interaction happens
     * so does not wait until end of the current period to run.
     *
     * - Does NOT run immediately by default
     */
    NotIdle.prototype.immediately = function (immediate) {
        if (immediate === void 0) { immediate = true; }
        this.immediate = immediate;
        return this;
    };
    return NotIdle;
}(Base));
export { NotIdle };
//# sourceMappingURL=/home/travis/build/harunurhan/idlejs/src/not-idle.js.map


//////////////////
// WEBPACK FOOTER
// D:/Aliva/IPCL/IPCL_SELF_CARE/~/idlejs/dist/not-idle.js
// module id = ../../../../idlejs/dist/not-idle.js
// module chunks = 4